import React from "react";
import "./CompassiaLanding.css"
import {SEOManager} from "../../utilities/SEOManager";
import {Navbar} from "../../components/NavBar";
import {Container, Feature, SectionTitle} from "../../components/LayoutHelpers";
import {IconLightning, IconPuzzle, IconRocket, IconTools} from "../../components/Icons";
import {Step} from "../../components/Step";
import {Testimonial} from "../../components/Testimonial";
import Footer from "../../sections/Footer/Footer";
import FAQSection from "../../sections/FAQSection/FAQSection";
import CTASection from "../../sections/CTASection/CTASection";
import HeroSection from "../../sections/HeroSection/HeroSection";
import LogosSection from "../../sections/LogosSection/LogosSection";

export default function CompassiaLanding() {
    return (
        <div id="inicio" className="page">
            <SEOManager />
            <Navbar />

            <main id="content">
                <HeroSection />
                <LogosSection />


                {/* Servicios (n8n + ampliados) */}
                <section id="servicios" className="section-alt">
                    <Container>
                        <SectionTitle
                            eyebrow="Finanzas"
                            title="Quitate trabajo de contabilidad"
                            subtitle="Soluciones a medida para que tu equipo haga más con menos."
                        />
                        <div className="grid-3">
                            <Feature icon={IconPuzzle} title="Registro de facturas mediante foto" desc="Desde tu movil a tu sistema" />
                            <Feature icon={IconLightning} title="Generacion de modelos (borradores*)" desc="Pre-cálculo de modelos (303, 130, 131, 390, 347, 349) para revisión de gestoría." />
                            <Feature icon={IconTools} title="Consultas por Slack/WhatsApp" desc="Saldo, IVA acumulado, vencimientos y KPIs. Guardarraíles y sin exponer PII." />
                            <Feature icon={IconRocket} title="Agenda y recordatorios" desc="Vencimientos, modelos, cobros. Ventanas horarias y snooze." />
                            <Feature icon={IconLightning} title="Flujo de caja" desc="Proyección 8–12 semanas con umbrales y acciones sugeridas." />
                        </div>
                        <p className="disclaimer">* No es asesoramiento fiscal. Los modelos se generan como borradores para revisión de gestoría.</p>
                    </Container>
                </section>

                {/* RAG privado */}
                <section id="rag">
                    <Container>
                        <SectionTitle
                            eyebrow="Documentación"
                            title="Tu conocimiento siempre disponible"
                            subtitle="Empodera tu organización y olvidate de la paralisis por analisis"
                        />
                        <div className="grid-3">
                            <Feature icon={IconLightning} title="Seguridad" desc="VPC, IAM por rol, cifrado KMS y sin retención de datos." />
                            <Feature icon={IconPuzzle} title="Precisión" desc="Búsqueda híbrida (BM25+vector), re-rank y chunking 500–800 tokens." />
                            <Feature icon={IconRocket} title="Velocidad" desc="&lt; 2 s p95 con caché y prompts compactos. Citaciones siempre presentes." />
                        </div>
                    </Container>
                </section>

                {/* Leads & CRM */}
                <section id="crm" className="section-alt">
                    <Container>
                        <SectionTitle
                            eyebrow="Leads & CRM"
                            title="De lead a contrato, sin fricción"
                            subtitle="Conectamos tus canales, clasificamos leads, agendamos según disponibilidad y automatizamos propuestas y firma."
                        />
                        <div className="grid-3">
                            <Feature icon={IconRocket} title="Agenda inteligente" desc="Disponibilidad multi-calendario, slots propuestos, recordatorios y reprogramación." />
                            <Feature icon={IconLightning} title="Clasificación y score" desc="Normaliza, deduplica, enriquece y puntúa leads según reglas y señales históricas." />
                            <Feature icon={IconPuzzle} title="Deal → contrato" desc="Plantillas, aprobaciones, envío a firma y alta automática en ERP." />
                            <Feature icon={IconTools} title="Higiene de datos" desc="Calidad de datos continua: duplicados, formatos, alertas de calidad." />
                        </div>
                    </Container>
                </section>

                {/* Proyecto a medida */}
                <section id="custom">
                    <Container>
                        <SectionTitle
                            eyebrow="Scope & Build"
                            title="Tu proceso, tus reglas"
                            subtitle="¿Tienes un proceso muy tuyo? Mapeamos el flujo end-to-end, priorizamos quick wins y estimamos por fases con métricas de impacto."
                        />
                        <div className="grid-3">
                            <Feature icon={IconPuzzle} title="Descubrimiento" desc="2–3 sesiones con equipo clave, mapa de proceso y riesgos." />
                            <Feature icon={IconLightning} title="Alcance por fases" desc="Entregables claros (DoD), hitos y criterios de éxito." />
                            <Feature icon={IconRocket} title="Piloto 2–4 semanas" desc="Quick win medible. Si aporta, escalamos y formamos al equipo." />
                        </div>
                        <div className="actions" style={{ marginTop: 16 }}>
                            <a href="#contacto" className="btn-primary">Agenda una sesión</a>
                            <a href="#faq" className="btn-outline">Cómo presupuestamos</a>
                        </div>
                    </Container>
                </section>

                {/* Proceso */}
                <section id="proceso" className="section-alt">
                    <Container>
                        <SectionTitle eyebrow="Proceso" title="Impacto medible en 3 pasos" subtitle="Sin re-plataformar. Nos integramos en lo que ya usas." />
                        <div className="grid-3 steps">
                            <Step index={1} title="Descubrimiento" desc="Nos reunimos con tu equipo para entender tu operación y métricas." />
                            <Step index={2} title="Piloto 2–4 semanas" desc="Implementamos 1–2 mejoras concretas y medimos impacto." />
                            <Step index={3} title="Escala y soporte" desc="Extendemos lo que funciona, formamos al equipo y monitorizamos." />
                        </div>
                    </Container>
                </section>

                {/* Casos */}
                <section aria-label="Casos de impacto">
                    <Container>
                        <SectionTitle eyebrow="comunidad" title="Testimonios de compassia" subtitle="Historias de colaboraciones finalizadas con exito" />
                        <div className="grid-3">
                            <Testimonial quote="Reducimos el tiempo de alta de pedidos un 41% conectando ecommerce→ERP y generando facturas automáticas." author="Retail mediano" role="Operaciones" />
                            <Testimonial quote="Clasificación y respuesta inicial de tickets con IA: SLA verde y 25% menos carga en soporte." author="SaaS B2B" role="Customer Support" />
                            <Testimonial quote="SuiteAnalytics + dashboards de ventas: forecast fiable y foco del equipo en deals con mayor ROI." author="Distribución" role="Dirección Comercial" />
                        </div>
                    </Container>
                </section>

                <FAQSection />
                <CTASection />

            </main>

            <Footer />
        </div>
    );
}
